import { useTranslation } from 'react-i18next'
import { YearlyEventVisibility } from '@/api/model/yearlyEventVisibility'
import { RadioGroup, RadioGroupItem } from '@/components/shadcn/radio-group'
import { Label } from '@/components/shadcn/label'

const OPTION_VALUES: YearlyEventVisibility[] = [
  YearlyEventVisibility.Hidden,
  YearlyEventVisibility.Visible,
  YearlyEventVisibility.VisibleWithYear,
]

interface Props {
  title: string
  value: YearlyEventVisibility | undefined
  onChange: (value: YearlyEventVisibility) => void
  disabled?: boolean
}

/** Three-option radio for the visibility of yearly events (birthdays/anniversaries). */
export function YearlyVisibilityPicker({ title, value, onChange, disabled }: Props) {
  const { t } = useTranslation('service-modules-calendar')
  return (
    <div className="flex flex-col gap-2">
      <p className="text-sm font-medium">{title}</p>
      <RadioGroup
        value={value}
        onValueChange={(v) => onChange(v as YearlyEventVisibility)}
        disabled={disabled}
        className="gap-2"
      >
        {OPTION_VALUES.map((optionValue) => {
          const id = `${title}-${optionValue}`
          return (
            <div key={optionValue} className="flex items-center gap-2">
              <RadioGroupItem value={optionValue} id={id} />
              <Label htmlFor={id} className="font-normal">
                {t(`calendar.visibility.${optionValue}`)}
              </Label>
            </div>
          )
        })}
      </RadioGroup>
    </div>
  )
}
